<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title *ngIf="!isVisitante">{{'Buscar Pessoa' | translate}}</ion-title>
    <ion-title *ngIf="isVisitante">{{'Buscar Visitante' | translate}}</ion-title>

    <ion-col class="end-filter" *ngIf="exibirFiltroMembrosTodasFiliais">
      <i class="fa fa-filter" (click)="toggleFilter()"></i>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido" *ngIf="idGrupo"></div>

  <div class="gradient-extendido" [ngStyle]="{ height: !idGrupo ? '90px' : '30px'}" *ngIf="!idGrupo">
    <div *ngIf="!idGrupo">
      <ion-segment mode="ios" value="aba" [(ngModel)]="aba" class="segment-gradient-title" (ionChange)="radioChange($event)">
        <ion-segment-button value="nome">
          <ion-label class="header">{{'Nome' | translate}}</ion-label>
        </ion-segment-button>

        <ion-segment-button value="1">
          <ion-label class="header" *ngIf="!recadastro">{{'Identificação' | translate}}</ion-label>
          <ion-label class="header" *ngIf="recadastro">{{'Código de membro' | translate}}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <div>
      <ion-searchbar show-cancel-button="never" placeholder="{{'Buscar Pessoa' | translate}}"
        [(ngModel)]="filtro.q" (ionInput)="onInput()" class="custom">
      </ion-searchbar>
    </div>
  </div>

  <ion-card-content>
    <ion-grid>
      <ion-row *ngIf="recadastro">
        <ion-col size="12" (click)="pendentes(pendente)">
          <ion-item lines="none">
            <ion-checkbox justify="space-between" [checked]="pendente" labelPlacement="start">
              {{'Listar apenas pendentes' | translate}}
            </ion-checkbox>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row *ngFor="let a of pessoaList;" (click)="selecionar(a);" class="row-list">
        <ion-col size="2">
          <ion-avatar>
            <img [src]="a.foto | image:' '" class="avatar-image" />
          </ion-avatar>
        </ion-col>

        <ion-col class="detalhes" size="9">
          <div>
            <h3>{{a.nome}}</h3>

            <p *ngIf="userProvider.hasConfig(117)" class="tipo-membro">
              {{ a.tipoPessoa }} {{ a?.tipomembroNome ? '/' : '' }} {{ a.tipomembroNome?.toLowerCase() }}
            </p>
          </div>

          <div class="item-description" *ngIf="recadastro && a.nascimento ">
            <p class="description-text bold-1" text-capitalize>
              {{a.nascimento ? (a.nascimento | dateFormat:'ddmmyyyy') : ('Não Informado' | translate)}}
            </p>
          </div>

          <div *ngIf="recadastro && a.codigo2 && a.codigo2 === '1'">
            <p>{{'NÃO QUER O APLICATIVO' | translate}}</p>
          </div>

          <div *ngIf="recadastro && a.codigo2 && a.codigo2 === '2'">
            <p>{{'FALECIDO' | translate}}</p>
          </div>

          <div *ngIf="recadastro && a.codigo2 && a.codigo2 === '3'">
            <p>{{'AFASTADO' | translate}}</p>
          </div>

          <div *ngIf="recadastro && a.codigo2 && a.codigo2 === '4'">
            <p>{{'NÃO LOCALIZADO' | translate}}</p>
          </div>

          <div *ngIf="recadastro && a.codigo2 && a.codigo2 === '5'">
            <p>{{'RECUSOU-SE A ATUALIZAR' | translate}}</p>
          </div>

          <div *ngIf="recadastro && a.codigo2 && a.codigo2 === '6'">
            <p>{{'QUER O APLICATIVO' | translate}}</p>
          </div>

          <div *ngIf="a.instituicaoNome && isControle" class="instituicaoNome">
            <ion-icon class="icon-list" name="home"></ion-icon>
            <p>{{a.instituicaoNome}}</p>
          </div>
        </ion-col>

        <ion-col size="1">
          <i class="fa-solid fa-chevron-right icon-list"></i>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list class="list-item" *ngIf="!pessoaList.length">
      <sem-registro [text]="notFoundText"></sem-registro>
    </ion-list>

    <ion-infinite-scroll (ionInfinite)="loadPessoas($event)" *ngIf="pagination.currentPage < pagination.pageCount">
      <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-card-content>
</ion-content>